module.exports = __webpack_public_path__ + "static/media/policy_icon.6d0f26ab.svg";